import React, { useEffect, useState } from 'react';
import { ErrorMessage } from '@hookform/error-message';
import { useForm, Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Form } from 'reactstrap';
import { useHistory } from 'react-router-dom';

import FlexSelect from 'components/Inputs/FlexSelect';
import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';
import {
  Button,
  Label
} from '../../../LoginQueueChat/components/LoginChatForm/styled';
import FlexChatIntegration from 'views/ServicePanel/components/QueueContent/components/Contact/service/FlexChatIntegration';

export function ChooseDialogTreeForm({ setLoading, setIsDropdownOpen }) {
  const history = useHistory();

  const [dialogTreeData, setDialogTreeData] = useState([]);
  const [selectedDialogTree, setSelectedDialogTree] = useState(null);

  const { control, handleSubmit, errors, setValue } = useForm();
  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  useEffect(() => {
    FlexChatIntegration.getAllDialogTreeWithGenerativeAI().then((res) => {
      setDialogTreeData(res.data ?? []);
    });
  }, []);

  const onSubmit = async (data) => {
    const mockedId = '06c7ceaa-f510-434c-ac8a-d4eb0cbbb83d';
    try {
      if (setLoading) setLoading(true);

      FlexChatIntegration.initChatWithGenerativeAI(mockedId, {
        chatBotId: data.dialogTreeId,
        user: {
          login: localStorage.getItem('login')
        }
      })
        .then((res) => {
          const idChat = res.data.chatId;
          setIsDropdownOpen(false);
          history.push(`/admin/service_panel`, { idChat });
          toast.success('Conversa iniciada com sucesso!');
        })
        .catch((err) => {
          toast.error(
            err.response?.data.errors[0] ?? 'Erro ao iniciar conversa'
          );
        });

      if (setLoading) setLoading(false);
    } catch (err) {
      toast.error(err.response?.data.errors[0] ?? 'Erro ao iniciar conversa');
      if (setLoading) setLoading(false);
    }
  };

  const handleDialogTreeChange = (selectedOption) => {
    setSelectedDialogTree(selectedOption);
  };

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  return (
    <>
      <Form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
        <div className="mb-2">
          <Label>Selecione o agente de IA Generativa</Label>
          <Controller
            render={(props) => (
              <FlexSelect
                dataOptions={dialogTreeData || []}
                isMulti={false}
                value={props.value}
                placeholder="Selecione um agente"
                isClearable={true}
                valueController={setValue}
                closeMenuOnSelect={true}
                fieldName="dialogTreeId"
                labelName="name"
                valueName="id"
                onChange={(option) => {
                  props.onChange(option);
                  handleDialogTreeChange(option);
                }}
              />
            )}
            defaultValue=""
            control={control}
            rules={{ required: 'Campo obrigatório!' }}
            name="dialogTreeId"
          />
          <ErrorMessage
            errors={errors}
            name="dialogTreeId"
            render={({ message }) => errorFormMessage(message)}
          />
        </div>

        <Button
          disabled={!selectedDialogTree}
          type="submit"
          title="Iniciar conversa"
          style={buttonStyle(systemConfiguration.primary_color)}
        >
          Iniciar Conversa
        </Button>
      </Form>
    </>
  );
}
